import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Toast } from "primereact";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import Loader from "../../../../Base/Components/Loader/Loader";
import { getUnidades } from "../../../../Base/API/Global/Unidades/UnidadesRequest";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../Base/Services/ToastService";

import { getEstadosCotizaciones } from "../../../../API/Global/Status/StatusRequests";
import { EditarAdditionalCost, GuardarAdditionalCost } from "../../../../API/Ventas/Cotizaciones/CotizacionesRequest";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";

const AdditionalCostCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected = () => {},
  modo,
  getInfo = () => {},
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [units, setUnits] = useState([]);

  const initialValues = {
    IdAdditionalCost: -1,
    IdStatus: selected ? selected?.IdStatus : 3706,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCotizaciones();
    setEstados(estadosTempo);
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    const unitsTempo = await getUnidades();
    setUnits(unitsTempo.filter((i) => [1, 3].includes(i.IdUnit)));

    const unitInicial = modo === "Crear" ? null : unitsTempo.find((e) => e.IdUnit === selected?.IdUnit)

    setValues({
      ...selected,
      IdAdditionalCost: selected ? selected?.IdAdditionalCost : -1,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      UnitName: unitInicial,
      IdUnit: unitInicial?.IdUnit,
    });
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Description) {
      error.Description = true;
      error.error = true;
    }
    if (modo === "Crear") {
      if (!values.UnitName || values?.IdUnit) {
        error.IdUnit = true;
        error.error = true;
      }
        if (!values.Estado || !values.Estado.IdStatus) {
          error.IdStatus = true;
          error.error = true;
        }
    } else {
      if (!values.Estado || !values.Estado.IdStatus) {
        error.IdStatus = true;
        error.error = true;
      }
      if (!values.UnitName || !values.IdUnit) {
        error.IdUnit = true;
        error.error = true;
      }
    }

    if (!values.Price) {
      error.Price = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdAdditionalCost: values?.IdAdditionalCost,
        ProcessCost: values?.ProcessCost,
        IdUnit: values?.UnitName?.IdUnit || values?.IdUnit,
        Price: values?.Price,
        Description: values?.Description,
        IdStatus: values?.Estado?.IdStatus,
        IdUserCreate: userAuth?.idUser,
        IdUserEdit: userAuth?.idUser,
        IdTipo: 1,
      };

      // console.log(Datos)

      setLoading(true);
      if (values?.IdAdditionalCost > 0) {
        const respuesta = await EditarAdditionalCost(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarAdditionalCost(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? `${getLabel(baseLang, "agregarCostoA", config.language)}` : `${getLabel(baseLang, "editarCostoA", config.language)}`;

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center mx-5">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Description"
                    value={values.Description}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Description ? "p-invalid" : ""}
                  />
                  <label htmlFor="Description">{getLabel(baseLang, "processCost", config.language)}</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"UnitName"}
                    value={values.UnitName}
                    items={units}
                    field={"UnitName"}
                    label={getLabel(baseLang, "unidad", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdUnit ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={getLabel(baseLang, "estado", config.language)}
                    handleInputChange={handleInputChange}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputNumber
                    name="Price"
                    value={values.Price}
                    onChange={handleInputChange}
                    minFractionDigits={2}
                    style={{ width: "100%" }}
                    className={error.Price ? "p-invalid" : ""}
                  />
                  <label htmlFor="Price">{getLabel(baseLang, "precio", config.language)}</label>
                </span>
              </div>
            </div>

            

          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AdditionalCostCRUD;
